import { Reveal, SectionHead } from "../components/Reveal";
import { BUILDING_IMAGE } from "../data/content";

const PRINCIPLES = ["Independência", "Imparcialidade", "Confidencialidade", "Observância das normas"];

export const Institutional = () => (
    <section id="instituicao" data-testid="institutional-section" className="bg-cream py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <div className="grid gap-16 lg:grid-cols-12">
                <div className="lg:col-span-7">
                    <SectionHead
                        eyebrow="A Instituição"
                        title="Administração institucional de arbitragem e mediação empresarial"
                    />
                    <Reveal delay={0.1} className="mt-8 space-y-6 text-base leading-relaxed text-graphite-text">
                        <p>
                            A CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo
                            atua na administração de procedimentos de arbitragem e mediação,
                            oferecendo um ambiente estruturado para a resolução de controvérsias de
                            natureza empresarial e patrimonial.
                        </p>
                        <p>
                            A arbitragem possui sólido fundamento jurídico no Brasil desde a{" "}
                            <strong className="font-semibold text-ink">Lei nº 9.307/1996</strong> —
                            Lei de Arbitragem — que consolidou a autonomia das partes para escolher
                            a arbitragem como meio de solução de conflitos envolvendo direitos
                            patrimoniais disponíveis. Em um ambiente empresarial marcado por
                            relações cada vez mais complexas e por elevado volume de demandas
                            judiciais, a busca por mecanismos adequados de resolução de conflitos
                            tornou-se um importante elemento de planejamento e segurança jurídica.
                        </p>
                    </Reveal>
                    <Reveal delay={0.18}>
                        <blockquote className="mt-10 border-l-2 border-gold pl-6">
                            <p className="font-serif text-xl italic leading-relaxed text-ink sm:text-2xl">
                                “A sentença arbitral produz, entre as partes e seus sucessores, os
                                mesmos efeitos da sentença proferida pelos órgãos do Poder
                                Judiciário e, quando condenatória, constitui título executivo.”
                            </p>
                            <cite className="mt-4 block font-mono text-[11px] not-italic uppercase tracking-[0.28em] text-gold-dark">
                                Art. 31 — Lei nº 9.307/1996
                            </cite>
                        </blockquote>
                    </Reveal>
                    <Reveal delay={0.24} className="mt-10 text-base leading-relaxed text-graphite-text">
                        <p>
                            A mediação, por sua vez, favorece o diálogo, a construção conjunta de
                            soluções e a preservação de relações comerciais, societárias e
                            contratuais. A atuação da CAJUSP busca oferecer procedimentos adequados
                            às características de cada caso, protegendo interesses legítimos,
                            relações comerciais e patrimônio.
                        </p>
                    </Reveal>
                </div>

                <div className="lg:col-span-5">
                    <Reveal delay={0.15} className="relative lg:mt-14">
                        <div className="relative overflow-hidden rounded-sm border border-cream-line">
                            <img
                                src={BUILDING_IMAGE.url}
                                alt={BUILDING_IMAGE.alt}
                                className="h-[420px] w-full object-cover"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
                        </div>
                        <div className="absolute -bottom-8 -left-4 w-56 border border-cream-line bg-white p-4 shadow-[0_18px_50px_rgba(18,21,25,0.12)] sm:-left-8 sm:w-64">
                            <img
                                src="/logo-cajusp.jpg"
                                alt="Logotipo oficial da CAJUSP — Câmara de Juízo Arbitral e Mediação Empresarial de São Paulo"
                                className="w-full"
                                loading="lazy"
                            />
                        </div>
                    </Reveal>
                </div>
            </div>

            <div className="mt-24 grid grid-cols-2 gap-x-8 gap-y-10 md:grid-cols-4">
                {PRINCIPLES.map((p, i) => (
                    <Reveal key={p} delay={0.08 * i}>
                        <div className="border-t border-cream-line pt-5">
                            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold-dark">
                                0{i + 1}
                            </p>
                            <p className="mt-2 font-serif text-xl text-ink">{p}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
